import React, { memo } from 'react';
import { Card } from 'react-bootstrap';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect, useDispatch } from 'react-redux';
import { makeGetAnalFSRatio } from 'lib/selector';

import FinacialStock from './layout/finacialStock';
import KetQuaKinhDoanh from './layout/ketQuaKinhDoanh';
import DongTien from './layout/dongTien';
import KhaNangSinhLoi from './layout/khaNangSinhLoi';

import { analFSRatioRequest } from 'containers/market/actions';
import { analFSRatioSuccess } from 'containers/market/actions';
import { analRankFSRatioRequest } from 'containers/market/actions';
import { analRankFSRatioSuccess } from 'containers/market/actions';
import { makeGetAnalRankFSRatio } from 'lib/selector';
// import { log } from 'utils';
import { numberFormat } from 'utils';

function PanelFinacial(props) {
  const [tabActive, setTabActive] = React.useState('cdkt');
  const [freqActive, setFreqActive] = React.useState('Q');

  const { symbol, analFSRatio, analRankFSRatio, t, lang, theme } = props;
  const dispatch = useDispatch();

  React.useEffect(() => {

    return () => {
      // cleanup
      dispatch(analFSRatioSuccess(null));
      dispatch(analRankFSRatioSuccess(null));
    };
  }, []);

  React.useEffect(() => {
    getFSRatio();
    getRankFSRatio()
  }, [symbol]);

  React.useEffect(() => {
    getFSRatio();
  }, [freqActive]);

  function getFSRatio() {
    const params = { lang, secCode: symbol, freq: freqActive };
    dispatch(analFSRatioRequest(params));
  }
  
  function getRankFSRatio() {
    const params = { lang, secCode: symbol, freq: freqActive };
    dispatch(analRankFSRatioRequest(params));
  }

  // log(analRankFSRatio);

  return (
    <div className="d-flex">
      <Card
        className="w-100 mt-2 mr-2"
        style={{ height: 'calc(100vh - 185px)', background: '#020210' }}
      >
        <Card.Header className="d-flex py-0 pr-2 tabs-cash">
          <a
            className={'fz-14 ' + (tabActive === 'kqkd' ? 'active' : '')}
            style={{ padding: '8px 0' }}
            onClick={() => setTabActive('kqkd')}
          >
            {t('algo.ptcp.txt-Income-statement')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'cdkt' ? 'active' : '')}
            style={{ padding: '8px 0' }}
            onClick={() => setTabActive('cdkt')}
          >
            {t('algo.ptcp.txt-Balance-sheet')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'dongtien' ? 'active' : '')}
            style={{ padding: '8px 0' }}
            onClick={() => setTabActive('dongtien')}
          >
            {t('algo.ptcp.txt-Cash-flow-statement')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'knsl' ? 'active' : '')}
            style={{ padding: '8px 0' }}
            onClick={() => setTabActive('knsl')}
          >
            {t('algo.ptcp.txt-Profitability')}
          </a>
        </Card.Header>
        <Card.Body className="p-0">
          {tabActive === 'cdkt' && (
            <FinacialStock
              freqActive={freqActive}
              setFreqActive={setFreqActive}
              fsRatio={analFSRatio}
              t={t}
              theme={theme}
            />
          )}
          {tabActive === 'kqkd' && (
            <KetQuaKinhDoanh
              freqActive={freqActive}
              setFreqActive={setFreqActive}
              fsRatio={analFSRatio}
              t={t}
              theme={theme}
            />
          )}
          {tabActive === 'dongtien' && (
            <DongTien
              freqActive={freqActive}
              setFreqActive={setFreqActive}
              fsRatio={analFSRatio}
              t={t}
              theme={theme}
            />
          )}
          {tabActive === 'knsl' && (
            <KhaNangSinhLoi
              freqActive={freqActive}
              setFreqActive={setFreqActive}
              fsRatio={analFSRatio}
              t={t}
              theme={theme}
            />
          )}
        </Card.Body>
      </Card>
      <Card
        className=" mt-2"
        style={{
          height: 'calc(100vh - 185px)',
          background: '#020210',
          width: '460px',
        }}
      >
        <Card.Header style={{ padding: '8px 16px' }}>
          <span className="color-apec fz-14">
            {t('algo.ptcp.txt-Growth-Value-Quality')}
          </span>
        </Card.Header>
        <Card.Body className="p-0">
          <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
            <table className="table table-borderless table-financial">
              <tbody>
                <tr className="head">
                  <td>{t('algo.ptcp.txt-val-12m')}</td>
                  <td className="text-right">{symbol}</td>
                  <td className="text-right">{t('algo.ptcp.txt-Sector')}</td>
                  <td className="text-right">{t('algo.ptcp.txt-market')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">P/E</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_PE, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_PE, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_PE, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">{t('algo.ptcp.txt-EPS-growth')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_EPS_GROWTH_QY, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_EPS_GROWTH_QY, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_EPS_GROWTH_QY, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">P/Tangible BV</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_PRICE_BVPST, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_PRICE_BVPST, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_PRICE_BVPST, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">P/S</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_PS, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_PS, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_PS, 2, '0')}</td>
                </tr>
                <tr className="head">
                  <td colSpan={'4'}>{t('algo.ptcp.txt-Growth')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">{t('algo.ptcp.txt-Revenue')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_REV_GROWTH_1Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_REV_GROWTH_1Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_REV_GROWTH_1Y, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">EPS (%)</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_EPS_GROWTH_1Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_EPS_GROWTH_1Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_EPS_GROWTH_1Y, 2, '0')}</td>
                </tr>
                <tr className="head">
                  <td colSpan={'4'}>{t('algo.ptcp.txt-CAGR')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">{t('algo.ptcp.txt-Revenue')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_REV_GROWTH_3Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_REV_GROWTH_3Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_REV_GROWTH_3Y, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">EPS (%)</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_EPS_GROWTH_3Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_EPS_GROWTH_3Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_EPS_GROWTH_3Y, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">DPS (%)</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_DPS_GROWTH_3Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_DPS_GROWTH_3Y, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_DPS_GROWTH_3Y, 2, '0')}</td>
                </tr>
                <tr className="head">
                  <td colSpan={'4'}>{t('algo.ptcp.txt-Quality')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">ROA (%)</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_ROA, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_ROA, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_ROA, 2, '0')}</td>
                </tr>
                <tr className="content">
                  <td className="content-label">ROE (%)</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.SEC_ROE, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.IND_ROE, 2, '0')}</td>
                  <td className="content-text text-right">{numberFormat(analRankFSRatio?.MK_ROE, 2, '0')}</td>
                </tr>
                {/* <tr className="">
                  <td
                    colSpan={'4'}
                    style={{ color: '#F0B90B', padding: '8px 12px' }}
                    className="fw-500"
                  >
                    Quán tính
                  </td>
                </tr>
                <tr className="head">
                  <td colSpan={'4'}>Sức mạnh tương đương (%)</td>
                </tr>
                <tr className="content">
                  <td className="content-label" colSpan={'3'}>
                    1 tháng (%)
                  </td>
                  <td className="content-text text-right">-15.43</td>
                </tr>
                <tr className="content">
                  <td className="content-label" colSpan={'3'}>
                    3 tháng (%)
                  </td>
                  <td className="content-text text-right">-5.62</td>
                </tr>
                <tr className="content">
                  <td className="content-label" colSpan={'3'}>
                    1 năm (%)
                  </td>
                  <td className="content-text text-right">23.66</td>
                </tr> */}
              </tbody>
            </table>
          </PerfectScrollbar>
        </Card.Body>
      </Card>
    </div>
  );
}
const makeMapStateToProps = () => {
  const getAnalFSRatio = makeGetAnalFSRatio();
  const getAnalRankFSRatio = makeGetAnalRankFSRatio();

  const mapStateToProps = (state) => {
    return {
      analFSRatio: getAnalFSRatio(state),
      analRankFSRatio: getAnalRankFSRatio(state),
      lang: state.client?.setting?.lang || 'vi'
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(PanelFinacial));
